export default "__VITE_ASSET__DKRt_0lB__"